import {sortBy} from 'lodash';
import {useMemo} from 'react';
import {isUpcomingMeeting} from '../../filters/meetingFilters';
import {useMeetings} from './useMeetings';
import {DEFAULT_MEETINGS_ORDER_BY} from './constants';

export function useUpcomingMeetings(eventId, {count, filter, sortBy: orderBy = DEFAULT_MEETINGS_ORDER_BY} = {}) {
    const meetings = useMeetings(eventId, {filter: isUpcomingMeeting});
    return useMemo(() => {
        let result = meetings;
        if (filter) result = result.filter(filter);
        if (orderBy) result = sortBy(result, orderBy);
        if (count) result = result.slice(0, count);
        return result;
    }, [meetings, count, filter]);
}
